// @flow
import React from 'react';
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import DesktopImageFile from '../../assets/TAXDOWN_970x250.jpg';
import MobileImageFile from '../../assets/TAXDOWN_300x250_2.jpg';

const Inner = styled.div`
  width: 100%;
  max-width: 970px;
  margin: 10px auto 30px;
  text-align: center;

  ${maxMediaQueries.tablet`
    max-width: 300px;
  `}
`;

const DesktopImage = styled.img`
  display: block;
  width: 100%;
  ${maxMediaQueries.tablet`
    display: none;
  `}
`;

const MobileImage = styled.img`
  display: none;
  width: 100%;
  ${maxMediaQueries.tablet`
    display: block;
  `}
`;

export const Taxdown = () => (
  <Inner>
    <a href="https://taxdown.es/partners/finect/signup?utm_source=Finect&utm_medium=Partnership&utm_campaign=TaxDown_ESP_X_Es_Partner_X_Renta2019-X-X-X_X_Br_X_Mad_Finance&utm_content=ESP_Es_Perf-Suscripcion_Partner_Conv_Gen_RevShare_3p-Discount-Renta-X_Finect_Texto_no-aplica">
      <DesktopImage src={DesktopImageFile} />
      <MobileImage src={MobileImageFile} />
    </a>
  </Inner>
);
